import * as React from 'react';

import './styles.scss';
import Icon, { IconsAvailable } from '../Icon';
import Button, { IButtonProps } from '../Button';
import Buttons from '../Buttons';
import Tags, { ITag } from '../Tags';
import classNames from 'classnames';

export interface ICollapsibleHeaderProps {
    /** Title */
    title: React.ReactNode;
    /** Description to display */
    description?: React.ReactNode;
    /** Open state */
    open?: boolean;
    /** Toggle action */
    toggle?: () => void;
    /** Arrow theme */
    arrowTheme?: 'arrow' | 'arrow2' | 'arrow3' | 'arrow4' | 'arrow5' | 'arrow6' | 'arrow7';
    /** Buttons to display */
    buttons?: IButtonProps[];
    /** Layouts to choose from */
    layout?: 'default' | 'menu-item' | 'filter-group';
}

/**
 * Collapsible component header.
 */
export const CollapsibleHeader: React.FunctionComponent<ICollapsibleHeaderProps> = (props) => {
    let arrowTheme = 'arrow';
    let arrowUp: IconsAvailable = 'arrow1-up';
    let arrowDown: IconsAvailable = 'arrow1-down';

    if (props.arrowTheme) {
        arrowTheme = props.arrowTheme;
        arrowUp = arrowTheme + '-up' as IconsAvailable;
        arrowDown = arrowTheme + '-down' as IconsAvailable;
    }

    if (props.layout === 'menu-item') {
        return (
            <div className="collapsible-header layout-menu-item">
                <div className="collapsible-header-title">{props.title}</div>
                <a href="#" className="collapsible-header-arrow" onClick={props.toggle}>
                    <Icon width={16} height={16} kind={props.open ? 'minus' : 'plus'}/>
                </a>
            </div>
        );
    }

    return (
        <div className={classNames('collapsible-header', {
            'layout-default': !props.layout || props.layout === 'default',
            'layout-filter-group': props.layout === 'filter-group',
            'open': props.open,
        })} onClick={props.toggle}>
            <div className="collapsible-header-arrow">
                <Icon width={16} height={16} kind={props.open ? arrowUp : arrowDown}/>
            </div>
            <div className="collapsible-header-content" onClick={props.toggle}>
                <div className="collapsible-header-title">{props.title}</div>
                {props.description && (
                    <div className="collapsible-header-description">{props.description}</div>
                )}
            </div>
            {props.buttons && !!props.buttons.length && (
                <Buttons>
                    {props.buttons.map((b, i) => (
                        <Button
                            key={i}
                            {...b}
                            size="small"
                        />
                    ))}
                </Buttons>
            )}
        </div>
    );
};

CollapsibleHeader.displayName = 'CollapsibleHeader';

export default CollapsibleHeader;
